import dayjs from "dayjs";
import styled from "styled-components";

import { useBIMClass, useParameter } from "../../../../modules/shared-entities";
import { Card, CardFace3, CardSkeleton } from "../../../../modules/ui-kit";
import objectIDToDate from "../../utils/objectIDToDate";

const StyledCard = styled(Card)`
    color: #fff;

    & > div {
        flex: 1 1 auto;
    }

    & > span {
        flex: none;
    }

    .bimclass {
        font-size: 1.2rem;
        opacity: .6;

        &:not(:empty)::before {
            content: " of ";
            font-size: .8rem;
            opacity: .4;
        }
    }

    .type {
        opacity: .3;
        text-align: right;
        width: 8rem;
    }

    &:hover {
        .bimclass {
            opacity: 1;
        }

        .type {
            opacity: .5;
        }
    }
`;

export default function Card2(props) {
    const { bimClassID, id, parameterID, revitBuiltInParameterID, revitSharedParameterDefinition, ...restProps } = props;

    const parameterQuery = useParameter(parameterID);
    const bimClassQuery = useBIMClass(bimClassID);

    if (parameterQuery.loading || bimClassQuery.loading) return <CardSkeleton />;

    return (
        <StyledCard { ...restProps }>
            <CardFace3>
                <span className="name fluid-accent">{ parameterQuery.data.parameter.name[0].text }</span>
                <span></span>
                <span>{ dayjs(objectIDToDate(id)).format("YYYY-MM-DD HH:mm:ss") }</span>
            </CardFace3>
            <span className="bimclass">{ bimClassQuery.data?.bimClass?.data?.name?.[0]?.text ?? "" }</span>
            <span className="type">
                {
                    revitBuiltInParameterID
                        ? "Built-In"
                        : "Shared"
                }
            </span>
        </StyledCard>
    );
}
